export const CURRENCY_ENABLED = process.env.REACT_APP_CURRENCY_ENABLED === 'true' || false;
export const SUPPORTED_CURRENCIES = process.env.REACT_APP_SUPPORTED_CURRENCIES;
export const DEFAULT_CURRENCY = process.env.REACT_APP_DEFAULT_CURRENCY || 'USD'; 